const $ = require('jquery');
const i18next = require('i18next');

const ApiLegacy = require('./Api');
const Api = require('./ApiV2');
const Caretaker = require('./utils/Caretaker');
const Storage = require('./utils/Storage');
const Localization = require('./utils/Localization');
const Preloader = require('./utils/Preloader');
const Ui = require('./utils/Ui');
const Map = require('./utils/Map');
const Editor = require('./utils/Editor');
const AddressSearch = require('./utils/AddressSearch');
const AddressRouting = require('./utils/AddressRouting');
const OpenFile = require('./utils/OpenFile');
const FileUpload = require('./utils/FileUpload');
const constants = require('./data/constants');

const User = require('./data/User');
const File = require('./data/File');

const Tips = require('./utils/Tips');

const storage = new Storage();
const localization = new Localization();
let api = new Api(localization);
const preloader = new Preloader();
preloader.showCursorPreloader();

const validateLogin = function (loggedUser) {
  return new Promise((resolve, reject) => {
    api.getFileList(loggedUser.sessionId)
      .then((files) => {
        resolve(files);
      })
      .catch(() => {
        reject();
      });
  });
};

class App {
  constructor(loggedUser, files) {
    this.user = loggedUser;
    this.files = files;
    this.openFile = null;
    this.addressRouting = null;
    this.editor = new Editor(preloader);
    this.uiFileListModal = $('.modal-file-list');
    this.uiCreateFileModal = $('.modal-create-file');
    this.uiFileListContextMenu = $('#filelist-row-context-menu');
    this.uiVehicleProfileContainer = $('#truck-attributes-settings');
    this._map = null;
    this._provider = null;
    this.tips = null;
    this.iwTruckAttributes = null;
    window.showBirdsview = false;

    this.caretaker = new Caretaker(storage);
  }

  init(user, language, provider) {
    this._provider = provider;

    return new Promise((resolve, reject) => Promise.all([localization.init(language), new Map('.map', storage, provider, true)])
      .then((values) => {
        Ui.translateElements();
        Ui.addListeners(this);

        if(Api.isStaging()) {
          localStorage.setItem("isStaging", true);
          $('#set-server-url-debug').removeClass('d-none');
        } else {
          localStorage.setItem("isStaging", false);
          localStorage.removeItem('debugServerUrl');
          $('#set-server-url-debug').addClass('d-none');
        }

        // eslint-disable-next-line
        this._map = values[1];
        try {
          // init map
          this._map.init();

          // init routing manager
          IWRoutingManager.initialize(this._map.map, false, false);

          this.addListeners();
          //this.fetchPriorityValues(this.user.sessionId);

          this._map.initMainRenderer();

          IWRoutingManager._renderer = this._map._renderer;
          this.tips = new Tips(storage, localization);

          // init file upload manager
          const fileUpload = new FileUpload(
            this.files,
            this.user.sessionId,
            api,
            preloader,
            (uploadedFile) => {
              this.loadFileInEditor(uploadedFile.id);
              this.updateFileList();
            },
          );
          fileUpload.init();

          this.iwTruckAttributes = new IWTruckAttributes(this._map.map);
          this.updateTruckRestrictionVisibility();
          this.iwTruckAttributes.showTruckattributes();

          // init address search and routing
          const geocoder = new IWGeocoderClient();

          /*
          if(Api.isDevelopment()) {
            geocoder.setProvider(provider + "-staging");
          } else {
            geocoder.setProvider(provider);
          }
          */
          this.addressRouting = new AddressRouting(this._map.map, geocoder, preloader, storage, this.user.sessionId);
          this.addressRouting.init()
            .then(() => {
              const addressSearch = new AddressSearch(this._map.map, geocoder, preloader, storage, this.addressRouting);
              addressSearch.init();
            });

          if(Api.isDevelopment()) {
            IWRoutingManager.setProvider(provider + "_staging");
          }
          //IWRoutingManager.setProvider(provider + "_staging");

          this.setLoggedInUser();
          this.updateFileList();

          $('#modalMapTripVersionInfo').modal('show');

          Ui.showInfoBar('editor.titles.please-choose-an-action');

          this.restoreFileInEditor();
        } catch (e) {
          console.error(e);
        }

        resolve();
        preloader.hideCursorPreloader();
      })
      .catch((error) => {
        Ui.showModalError(localization.translate("errors.could-not-init-app", {errorMessage: error.message}));
        reject(error);
      }),

    setInterval(() => {
      validateLogin(user)
        .catch((error) => {
          console.error(error);
          window.location = 'login.html';
        });
    }, 300000) // every 5 minutes
  )}

  updateFileList() {
    Ui.updateFileList(this.files, localization)
      .then(result => {
        const {fileTableElement, fileTable, rows} = result;

        let activeRow = null;

        rows.forEach(({ row, data, index }) => {
          if(data.active === true) {
            activeRow = {index, row, data};
          }

          // noinspection JSDeprecatedSymbols
          $(row)
            .on('contextmenu', (event) => {
              event.preventDefault();
              $('.editor-context-menu').hide();

              this.showFileListContextMenu(event, row, data);
            })
            .on('dblclick', (event) => {
              event.preventDefault();
              this.loadFileInEditor(data.id);
            });
        });

        fileTableElement.off('select.dt').on('select.dt', (e, dt, type, indexes) => {
          const selectedIndex = indexes[0];

          if(!activeRow || activeRow.index !== selectedIndex) {
            const newActiveRow = rows.find(row => {
              return row.index === selectedIndex;
            });

            const modal = $("#modalActivateFileConfirmation");

            let message = i18next.t('general.activateFileConfirmationBodyNewFile', {file: newActiveRow.data.name});

            if(activeRow) {
              message = i18next.t('general.activateFileConfirmationBody', {oldFile: activeRow.data.name, newFile: newActiveRow.data.name});
            }

            modal.find('.modal-body').html(message);
            modal.find("#modalActivateFileCancel").on("click", () => {
              modal.modal('hide');
              fileTable.row(newActiveRow.row).deselect();
              fileTable.row(activeRow.row).select();
            });

            modal.find("#modalActivateFileConfirm").off("click").on("click", () => {
              modal.modal('hide');
              activeRow = newActiveRow;

              preloader.showCursorPreloader();

              api.activateFile(this.user.sessionId, activeRow.data.id)
                .then(() => {
                  this.files.setFileAsActive(activeRow.data.id);
                  preloader.hideCursorPreloader();
                  Ui.showModalSuccess(i18next.t("editor.file-activated-successfully"));
                })
                .catch(error => {
                  console.log('App.js:196', error);
                  preloader.hideCursorPreloader();
                  Ui.showModalError(i18next.t("errors.could-not-activate-file"));
                });
            });

            modal.modal('show');
          }
        })

        if(activeRow !== null) {
          fileTable.row(activeRow.row).select();
        }
      })
      .catch((error) => {
        Ui.showModalError(localization.translate("errors.loading-app-error"));
        console.error(error);
      });
  }

  showFileListContextMenu(event, row, data) {
    const buttonLoad = this.uiFileListContextMenu.find('#editor-context-menu-load');
    const buttonDelete = this.uiFileListContextMenu.find('#editor-context-menu-delete');

    // Set the menu title
    this.uiFileListContextMenu.find('#filelist-row-context-menu-name').html(data.name);

    buttonLoad.off('click');
    // noinspection JSDeprecatedSymbols
    buttonLoad.on('click', () => {
      this.loadFileInEditor(data.id);
    });

    buttonDelete.off('click');
    // noinspection JSDeprecatedSymbols
    buttonDelete.on('click', () => {
      this.deleteFile(data.id);
    });

    this.uiFileListContextMenu.css({ left: event.pageX, top: event.pageY }).show();
  }

  restoreFileInEditor() {
    storage.getOption('currentOpenFile')
      .then((result) => {
        if (result === null || result.length < 1) {
          if(this.files._files.length === 1 && this.files._files[0]._version === -1) {

            if(!this.files._files[0]._active) {
              api.activateFile(this.user.sessionId, this.files._files[0]._id);
            }

            this.loadFileInEditor(this.files._files[0]._id)
          }
          return;
        }

        const file = File.deserialize(result[result.length - 1]);

        if(!this.files._files.some(fromList => fromList.id === file.id)) {
          if (this.files._files.length === 1 && this.files._files[0]._version === -1) {

            if (!this.files._files[0]._active) {
              api.activateFile(this.user.sessionId, this.files._files[0]._id);
            }

            this.loadFileInEditor(this.files._files[0]._id)
          }
          return;
        }

        this.caretaker.restore(result);
        this.setOpenFile(file);
      });
  }

  loadFileInEditor(fileId) {
    preloader.showCursorPreloader();
    this.uiFileListModal.modal('hide');

    api.getFileContents(this.user.sessionId, this.files.getByFileId(fileId))
      .then((file) => {
        this.setOpenFile(file, true);
        preloader.hideCursorPreloader();
      })
      .catch((error) => {
        Ui.showFileListHeader();
        Ui.showModalError(localization.translate("errors.selecting-file", {errorMessage: error.message}));
        console.error(error);
        preloader.hideCursorPreloader();
      });
  }

  unloadFileInEditor() {
    this.openFile.destroy();
    this.openFile = null;
  }

  setOpenFile(file, fresh) {
    Ui.showFileEditHeader();

    this.openFile = new OpenFile(
      file,
      this.caretaker,
      this._map,
      api,
      this.user.sessionId,
      preloader,
      localization,
      storage,
      this._provider,
      this.addressRouting,
      this.iwTruckAttributes
    );

    if (fresh) {
      this.openFile.fileChanged();
    }

    Ui.updateFile(file);
    Ui.showInfoBar('editor.hold-ctrl-to-add-points');

    const routeOptions = new IWRouteOptions();
    routeOptions.setUserDefinedProfiles([`olrclient_${file.company}_${file.user}_${file.name}`]);

    // HACK
    if(this.user.company === "fw_esslingen") {
      routeOptions.setMobilityProfile("types_emergency_truck.txt");
    }

    IWRoutingManager.setRouteOptions(routeOptions);

    // wait for turnrestrictions to be initialized
    setTimeout(() => {
      this.setTurnRestrictionsProject();
    }, 750);
  }

  setPredefinedRoute(start, destination) {
    const startCoordinates = start.split(',');
    const destinationCoordinates = destination.split(',');
    const startAddress = new IWAddress('', '', '', '', '', '', '', new IWCoordinate(startCoordinates[1], startCoordinates[0], IWCoordinate.WGS84));
    const destinationAddress =  new IWAddress('', '', '', '', '', '', '', new IWCoordinate(destinationCoordinates[1], destinationCoordinates[0], IWCoordinate.WGS84));
    this.addressRouting.setStartAddress(startAddress, startAddress, false);
    this.addressRouting.setEndAddress(destinationAddress, destinationAddress, true);
  }

  updateTruckRestrictionVisibility() {
    let restrictions = [];

    Promise.all([storage.getOption('showSoftRestrictions'), storage.getOption('showHardRestrictions')])
      .then(result => {
        if(result[0]) restrictions.push(IWTruckAttributes.RESTRICTION_TYPE_SOFT);
        if(result[1]) {
          restrictions.push(IWTruckAttributes.RESTRICTION_TYPE_HARD);
          this.iwTruckAttributes.showRoadsProhibitedForTrucks(this.user.sessionId);
        } else {
          this.iwTruckAttributes.hideRoadsProhibitedForTrucks();
        }

        if(restrictions.length > 0) {
          this.iwTruckAttributes.showRestrictionTypes(restrictions);
          this.iwTruckAttributes.showTruckattributes();
        } else {
          this.iwTruckAttributes.hideTruckattributes();
        }
      })
  }

  createFile(name) {
    const { files } = this.files;
    const fileExists = files.find(file => file.name.toLowerCase() === name.toLowerCase());

    if (fileExists) {
      Ui.showModalError(localization.translate("errors.file-already-exists", {fileName: name }));
      return;
    }

    preloader.showCursorPreloader();

    storage.getOption("user")
      .then((result) => {
        let user = result._username;
        let company = result._company;

        api.createFile(this.user.sessionId, name, user, company)
          .then((file) => {

            api.getFileList(this.user.sessionId)
              .then(files => {
                this.files = files;

                this.uiCreateFileModal.modal('hide');
                this.updateFileList();

                this.loadFileInEditor(file.id);
                preloader.hideCursorPreloader();
              });

          })
          .catch((error) => {
            Ui.showModalError(localization.translate("errors.creating-file", {errorMessage: error.message}));
            preloader.hideCursorPreloader();
          });

      });
  }

  getFileFromName(fileName) {
    return this.files.files.find((file) => {
      return file._name === fileName
    });
  }

  deleteFile(fileId) {
    const file = this.files.getByFileId(fileId);
    const question = localization.translate('editor.deletion-confirmation-warning3', { file: file.name });
    Ui.showModalConfirmation(question, localization.translate('editor.confirm-deletion'), () => {
      preloader.showCursorPreloader();

      api.deleteFile(this.user.sessionId, fileId)
        .then((result) => {
          if (result === true) {
            this.files.removeByFileId(fileId);
            this.updateFileList();
            preloader.hideCursorPreloader();
          } else {
            Ui.showModalError(localization.translate("errors.deleting-file"));
            preloader.hideCursorPreloader();
          }
        })
        .catch((error) => {
          Ui.showModalError(localization.translate("errors.deleting-file-message", {errorMessage: error.message}));
          preloader.hideCursorPreloader();
        });
    });
  }

  setLoggedInUser() {
    Ui.setLoggedInUser(this.user.username);
  }

  fetchPriorityValues(token) {
    api.getPriorityAttributes(token).then((prioAttributes) => {
      api.getPenalizeAttributes(token).then((penAttributes) => {
        let penValue = this.getValueFromPriority(penAttributes);
        let prioValue = this.getValueFromPriority(prioAttributes);
        if(penValue) {
          constants.PENALIZE_DEFAULT_VALUE = penValue;
          storage.putOption('penalizeValue', penValue);
        }
        if(prioValue) {
          constants.PRIORITIZE_DEFAULT_VALUE = prioValue;
          storage.putOption('priorityValue', prioValue);
        }

      })
    });
  }

  getValueFromPriority(priority) {
    let value = 0;
    priority.forEach(ele => {
      if(ele.name === constants.PRIORITY_ATTRIBUTE_NAME) {
        value = ele.value;
      }
    });
    return value;
  }

  setTurnRestrictionsProject() {
    let alias = this._map.map.getOptions().getMapTypeByName(window.mapType).getTilesServerConfig().getAliases()[0];
    let start = alias.indexOf('&project=');
    let project = "test";
    if (start > -1) {
      let end = alias.indexOf('&', start + 1);
      project = end > -1
        ? alias.substring(start, end)
        : alias.substring(start);
      project = project.split("=")[1];
    }
    this.openFile._turnRestrictions.setMapProject(project);
  }

  fillTruckProfile() {
    storage.getOption("truckProfile")
      .then(res => {
        if(res) {
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-width').val(res.vehicleWidth !== "0" ? res.vehicleWidth : '');
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-height').val(res.vehicleHeight !== "0" ? res.vehicleHeight : '');
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-weight').val(res.vehicleWeight !== "0" ? res.vehicleWeight/1000 : '');
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-length').val(res.vehicleLength !== "0" ? res.vehicleLength : '');
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-axleCount').val(res.vehicleAxles !== "0" ? res.vehicleAxles : '');
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-axleWeight').val(res.vehicleWeightPerAxle !== "0" ? res.vehicleWeightPerAxle/1000 : '');

          this.uiVehicleProfileContainer.find('#routing-truck-attribute-explosiveLoad').prop("checked", parseInt(res.vehicleLoadExplosive) === 1);
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-harmfulLoad').prop("checked", parseInt(res.vehicleLoadHarmfulToWater) === 1);
          this.uiVehicleProfileContainer.find('#routing-truck-attribute-hazardLoad').prop("checked", parseInt(res.vehicleLoadHazardous) === 1);
        }
      });
  }

  parseTruckRoutingAttributes() {
    return new Promise((resolve, reject) => {
      let truckAttributes = {};

      truckAttributes.vehicleWidth = this.uiVehicleProfileContainer.find('#routing-truck-attribute-width').val();
      truckAttributes.vehicleHeight = this.uiVehicleProfileContainer.find('#routing-truck-attribute-height').val();
      truckAttributes.vehicleWeight = (this.uiVehicleProfileContainer.find('#routing-truck-attribute-weight').val()*1000).toString();
      truckAttributes.vehicleLength = this.uiVehicleProfileContainer.find('#routing-truck-attribute-length').val();
      truckAttributes.vehicleAxles = this.uiVehicleProfileContainer.find('#routing-truck-attribute-axleCount').val();
      truckAttributes.vehicleWeightPerAxle = (this.uiVehicleProfileContainer.find('#routing-truck-attribute-axleWeight').val()*1000).toString();
      truckAttributes.vehicleLoadExplosive = this.uiVehicleProfileContainer.find('#routing-truck-attribute-explosiveLoad').prop("checked") ? 1 : 0;
      truckAttributes.vehicleLoadHarmfulToWater = this.uiVehicleProfileContainer.find('#routing-truck-attribute-harmfulLoad').prop("checked") ? 1 : 0;
      truckAttributes.vehicleLoadHazardous = this.uiVehicleProfileContainer.find('#routing-truck-attribute-hazardLoad').prop("checked") ? 1 : 0;

      storage.putOption("truckProfile", truckAttributes)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  setDefaultTruckRoutingAttributes() {
    let truckAttributes = {};

    truckAttributes.vehicleWidth = 2.55;
    truckAttributes.vehicleHeight = 4;
    truckAttributes.vehicleWeight = 40000;
    truckAttributes.vehicleLength = 18.75;
    truckAttributes.vehicleAxles = 5;
    truckAttributes.vehicleWeightPerAxle = 9000;
    truckAttributes.vehicleLoadExplosive = false;
    truckAttributes.vehicleLoadHarmfulToWater = false;
    truckAttributes.vehicleLoadHazardous = false;

    storage.putOption("truckProfile", truckAttributes);
  }

  addListeners() {
    // noinspection JSDeprecatedSymbols
    $('#closeEditing').on('click', () => {
      const closeFile = () => {
        const routeOptions = new IWRouteOptions();
        routeOptions.setUserDefinedProfiles([]);

        IWRoutingManager.setRouteOptions(routeOptions);

        Ui.showFileListHeader();
        this.unloadFileInEditor();
      };

      if (this.openFile.totalUnsavedChanges === 0) {
        closeFile();
      } else {
        Ui.showModalConfirmation(
          localization.translate('editor.you-have-unsaved-changes', { total: this.openFile.totalUnsavedChanges }),
          localization.translate('editor.confirm-close'),
          closeFile,
        );
      }
    });

    $('#btnLogout').on('click', (event) => {
      event.preventDefault();
      const actions = [storage.deleteOption('user'), storage.deleteOption('currentOpenFile')];
      preloader.showCursorPreloader();
      Promise.all(actions).then(() => {
        window.location = 'login.html';
        preloader.hideCursorPreloader();
      }).catch((error) => {
        preloader.hideCursorPreloader();
        console.error(error);
        Ui.showModalError(localization.translate("errors.could-not-logout"));
      });
    });

    $('body').on('shown.bs.modal', '.modal', function () {
      $('input:visible:enabled:first', this).trigger('focus');
    });

    const fileList = $('#fileList');

    fileList.on('click', '#btn-file-load', (event) => {
      const fileId = parseInt($(event.currentTarget).attr('rel'), 10);
      this.loadFileInEditor(fileId);
    });

    fileList.on('click', '#btn-file-delete', (event) => {
      const fileId = parseInt($(event.currentTarget).attr('rel'), 10);
      this.deleteFile(fileId);
    });

    let initialTruckRoutingSetting;

    storage.getOption('initialTruckRouting')
      .then((result) => {
        if(result === null || result === 'undefined') {
          initialTruckRoutingSetting = true;
        } else {
          initialTruckRoutingSetting = result;
        }
      });

    const truckRoutingSwitch = $('#truck-routing-switch');
    storage.getOption("truckRouting")
      .then((result) => {
        if(result === null || result === 'undefined') {
          truckRoutingSwitch.prop("checked", true);
          Ui.toggleTruckRoutingInput(true);
          storage.putOption("truckRouting", true);
        } else {
          truckRoutingSwitch.prop("checked", result);
          Ui.toggleTruckRoutingInput(result);
        }
        //this.updateTruckRestrictionVisibility();
      });
    truckRoutingSwitch.on("change", () => {
      let isChecked = truckRoutingSwitch.is(":checked");
      storage.putOption("truckRouting", isChecked);
      //this.updateTruckRestrictionVisibility();
      initialTruckRoutingSetting = isChecked;
      Ui.toggleTruckRoutingInput(isChecked);
      storage.putOption('initialTruckRouting', initialTruckRoutingSetting);
    });

    const turnRestrictionsSwitch = $('#turn-restriction-switch');
    storage.getOption("useTurnRestrictions")
      .then((result) => {
        if(result === null || result === 'undefined') {
          turnRestrictionsSwitch.prop("checked", true);
          Ui.toggleIgnoreTurnRestrictionsInput(true);
          storage.putOption("useTurnRestrictions", true);
        } else {
          turnRestrictionsSwitch.prop("checked", result);
          Ui.toggleIgnoreTurnRestrictionsInput(result);
        }
      });
    turnRestrictionsSwitch.on("change", () => {
      let isChecked = turnRestrictionsSwitch.is(":checked");
      storage.putOption("useTurnRestrictions", isChecked);
      Ui.toggleIgnoreTurnRestrictionsInput(isChecked);
    });

    const turnRestrictionEmergencySwitch = $('#turn-restriction-emergency-switch');
    storage.getOption("useTurnRestrictionsEmergency")
      .then((result) => {
        if(result === null || result === 'undefined') {
          turnRestrictionEmergencySwitch.prop("checked", true);
          Ui.toggleIgnoreTurnRestrictionsEmergencyInput(true);
          storage.putOption("useTurnRestrictionsEmergency", true);
        } else {
          turnRestrictionEmergencySwitch.prop("checked", result);
          Ui.toggleIgnoreTurnRestrictionsEmergencyInput(result);
        }
      });
    turnRestrictionEmergencySwitch.on("change", () => {
      let isChecked = turnRestrictionEmergencySwitch.is(":checked");
      storage.putOption("useTurnRestrictionsEmergency", isChecked);
      Ui.toggleIgnoreTurnRestrictionsEmergencyInput(isChecked);
    });

    const emergencyRoutingSwitch = $('#emergency-routing-switch');
    const emergencyRoutingButton = $('#buttonEmergencyRouting');
    storage.getOption("emergencyRouting")
      .then((result) => {
        if(result !== 'undefined') {
          emergencyRoutingSwitch.prop("checked", result);
          Ui.toggleEmergencyRoutingInput(result);

          if(result) {
            truckRoutingSwitch.prop("disabled", true);
            truckRoutingSwitch.prop("checked", false);
            Ui.toggleTruckRoutingInput(false);
            storage.putOption("truckRouting", false);

            emergencyRoutingButton.addClass('active');
            emergencyRoutingButton.find('img').attr('src', "img/siren-inverted.svg")
          } else {
            truckRoutingSwitch.prop("disabled", false);
            truckRoutingSwitch.prop("checked", initialTruckRoutingSetting);
            Ui.toggleTruckRoutingInput(initialTruckRoutingSetting);
            storage.putOption("truckRouting", initialTruckRoutingSetting);

            emergencyRoutingButton.removeClass('active');
            emergencyRoutingButton.find('img').attr('src', "img/siren.svg")
          }

        }
        storage.getOption("emergencyRadius")
          .then((result) => {
            if(result && result !== 'undefined' && result !== '0') {
              $('#emergency-radius-input').val(result);
            } else {
              $('#emergency-radius-input').val(constants.EMERGENCY_RADIUS_DEFAULT);
              storage.putOption("emergencyRadius", constants.EMERGENCY_RADIUS_DEFAULT);
            }
          });
      });
    emergencyRoutingSwitch.on("change", () => {
      let isChecked = emergencyRoutingSwitch.is(":checked");
      storage.putOption("emergencyRouting", isChecked);
      Ui.toggleEmergencyRoutingInput(isChecked);

      if(isChecked) {
        emergencyRoutingButton.addClass('active');
        emergencyRoutingButton.find('img').attr('src', "img/siren-inverted.svg");
      } else {
        emergencyRoutingButton.removeClass('active');
        emergencyRoutingButton.find('img').attr('src', "img/siren.svg");
      }

      if(isChecked) {
        truckRoutingSwitch.prop("disabled", true);
        truckRoutingSwitch.prop("checked", false);
        Ui.toggleTruckRoutingInput(false);
        storage.putOption("truckRouting", false);
      } else {
        truckRoutingSwitch.prop("disabled", false);
        truckRoutingSwitch.prop("checked", initialTruckRoutingSetting);
        Ui.toggleTruckRoutingInput(initialTruckRoutingSetting);
        storage.putOption("truckRouting", initialTruckRoutingSetting);
      }
    });

    emergencyRoutingButton.off().on('click', () => {
      let isChecked = emergencyRoutingSwitch.is(":checked");

      emergencyRoutingSwitch.prop("checked", !isChecked);
      emergencyRoutingSwitch.trigger('change');
      this.addressRouting.initRouting(true);

      emergencyRoutingButton.parent().tooltip('hide');
      emergencyRoutingButton.parent().tooltip('show');
    });

    const emergencyRadiusInput = $('#emergency-radius-input');
    emergencyRadiusInput.on('change', () => {
      let emergencyRadiusValue = emergencyRadiusInput.val();

      if(emergencyRadiusValue <= 0) {
        emergencyRadiusValue = 1;
        emergencyRadiusInput.val(emergencyRadiusValue);
      }

      storage.putOption("emergencyRadius", emergencyRadiusValue);
    });

    const tunnelRestrictionSelect = $('#tunnel-restriction-code');
    storage.getOption('tunnelRestrictionCode')
      .then(result => {
        if(!result) {
          tunnelRestrictionSelect.val('');
        } else {
          tunnelRestrictionSelect.val(result);
        }
      });
    tunnelRestrictionSelect.on('change', () => {
      let value = tunnelRestrictionSelect.val();
      storage.putOption('tunnelRestrictionCode', value);
    });



    /*
    $('#emergency-radius-input').on('keydown', (event) => {
      if(event.keyCode === 13) $('#emergency-routing-confirm').trigger('click');
      return Ui.checkIfValidNumberInput(event.keyCode);
    });

    $('#emergency-routing-confirm').on("click", () => {
      let radiusInput = $('#emergency-radius-input');
      let emergencyRadiusValue = radiusInput.val();

      if(emergencyRadiusValue <= 0) {
        emergencyRadiusValue = 1;
        radiusInput.val(emergencyRadiusValue);
      }

      storage.putOption("emergencyRadius", emergencyRadiusValue)
        .then((result) => {
          if(result) $('.modal-settings').modal("hide");
        });
    });
    */

    const airViewSwitch = $('#airview-switch');
    airViewSwitch.on('change', () => {
      let label = $('#airview-label');

      let useWMTSLayer = constants.WMTS_MAP_USER.includes(this.user._company.toLocaleLowerCase()) || constants.WMTS_MAP_USER.includes(this.user._username);

      window.showBirdsview = !window.showBirdsview;
      this._map.switchBirdseyeView(window.showBirdsview, useWMTSLayer);

      if(window.showBirdsview) {
        label.text(i18next.t("general.enabled"));
        label.data("translation-key", "general.enabled");
      } else {
        label.text(i18next.t("general.disabled"));
        label.data("translation-key", "general.disabled");
      }

      if(this.openFile) {
        setTimeout(() => {
          this.setTurnRestrictionsProject();
        }, 300);
      }

    });

    $('#buttonAirView').off().on('click', () => {
      airViewSwitch.trigger('change');
    });

    $('#language-picker .dropdown-item').each((index, element) => {
      const item = $(element);
      item.on('click', () => {
        this.updateFileList();
        this._map.map.removeInfoBalloon();
        this.tips.updateDataTranslationKeys();
      });
    });

    const softRestrictionsSwitch = $('#softrestrictions-switch');
    storage.getOption("showSoftRestrictions")
      .then((result) => {
        if(result === null || result === 'undefined') {
          softRestrictionsSwitch.prop("checked", false);
          Ui.toggleSoftrestrictionInput(false);
          storage.putOption('showSoftRestrictions', false);
        } else {
          softRestrictionsSwitch.prop("checked", result);
          Ui.toggleSoftrestrictionInput(result);
        }
      });
    softRestrictionsSwitch.on("change", () => {
      let isChecked = softRestrictionsSwitch.is(':checked');
      storage.putOption("showSoftRestrictions", isChecked)
        .then(() => {
          this.updateTruckRestrictionVisibility();
        });
      Ui.toggleSoftrestrictionInput(isChecked);
    });

    storage.getOption("truckProfile")
      .then(result => {
        if(result === null || result === 'undefined') {
          this.setDefaultTruckRoutingAttributes();
        }
      });

    const vehicleProfileSwitch = $('#vehicle-profile-switch');
    storage.getOption("useVehicleProfile")
      .then((result) => {
        if(result === null || result === 'undefined') {
          vehicleProfileSwitch.prop("checked", true);
          Ui.toggleVehicleProfileInput(true);
          storage.putOption("useVehicleProfile", true);
        } else {
          vehicleProfileSwitch.prop("checked", result);
          Ui.toggleVehicleProfileInput(result);
        }
      });
    vehicleProfileSwitch.on("change", () => {
      let isChecked = vehicleProfileSwitch.is(':checked');
      storage.putOption("useVehicleProfile", isChecked);
      Ui.toggleVehicleProfileInput(isChecked);
    });

    const hardRestrictionsSwitch = $('#hardrestrictions-switch');

    storage.getOption("showHardRestrictions")
      .then((result) => {
        if(result === null || result === 'undefined') {
          hardRestrictionsSwitch.prop("checked", true);
          Ui.toggleHardrestrictionInput(true);
          storage.putOption('showHardRestrictions', true)
            .then(() => {
              this.updateTruckRestrictionVisibility();
            });
        } else {
          hardRestrictionsSwitch.prop("checked", result);
          Ui.toggleHardrestrictionInput(result);
        }
      });

    hardRestrictionsSwitch.on("change", () => {
      let isChecked = hardRestrictionsSwitch.is(':checked');
      storage.putOption("showHardRestrictions", isChecked)
        .then(() => {
          this.updateTruckRestrictionVisibility();
        });
      Ui.toggleHardrestrictionInput(isChecked);
    });

    const debugServerUrl = $('#server-url-input');
    let debugUrl = localStorage.getItem('debugServerUrl');
    if(debugUrl === null || debugUrl === 'undefined' || debugUrl === '') {
      debugServerUrl.val('');
    } else {
      debugServerUrl.val(debugUrl);
    }
    debugServerUrl.on("change", (e) => {
      localStorage.setItem('debugServerUrl', $(e.target).val());
    });

    this.uiVehicleProfileContainer.find('input').off().on('change', (event) => {
      event.preventDefault();
      this.parseTruckRoutingAttributes();
    });

    $('#open-settings-modal').off().on('click', () => {
      if(this.openFile) {
        $('#check-file-body').removeClass('d-none');
      } else {
        $('#check-file-body').addClass('d-none');
      }
      this.fillTruckProfile();
      $('.modal-settings').modal('show');
    });

    $('#btnMapTripVersionRedirectOld').off().on('click', (e) => {
      e.preventDefault();
      window.location = "https://editor.maptrip.de/detour-outdated-v54/"
    });

    $('#btnMapTripVersionRedirect').off().on('click', (e) => {
      e.preventDefault();
      window.location = "https://editor.maptrip.de/detour-outdated-v55/";
    });

    $('.modal-settings').on('hide.bs.modal', () => {
      this.addressRouting.initRouting(true);
    })
  }
}

window.initApp = function () {
  return new Promise((resolve, reject) => {
    storage.init().then(() => {
      Promise.all([storage.getOption('user'), storage.getOption('language'), storage.getOption(constants.PROVIDER_STORAGE_KEY), storage.getOption('appMode')]).then((results) => {
        const savedUser = results[0];
        const language = results[1];
        const provider = results[2];
        const appMode = results[3];

        if (!savedUser) {
          window.location = 'login.html';
          return;
        }

        const {
          _company, _username, _sessionId, _flags,
        } = savedUser;

        const user = new User(_company, _username, _sessionId, _flags);

        validateLogin(user)
          .then((files) => {
            const app = new App(user, files);

            app.init(user, language, provider)
              .then(()=> {
                resolve(app);
              });
          })
          .catch((error) => {
            console.error(error);
            window.location = 'login.html';
          });
      }).catch((error) => {
        console.error(error);
        window.location = 'login.html';
      });

    });
  })
};
